import { BackIcon } from "@/app/components/system/Icons";
import { RoundButton } from "@/app/components/system/RoundButton";

interface EditScreenHeaderProps {
  /** Centered title in the header. */
  title: string;
  /** Right-side action label. Defaults to "Save". */
  saveLabel?: string;
  /** Whether the right-side action button is disabled. */
  saveDisabled?: boolean;
  /** Left-side back button handler. */
  onCancel: () => void;
  /** Right-side action button handler. */
  onSave: () => void;
}

/** Sticky three-column header used by edit screens: back · title · save. */
export function EditScreenHeader({
  title,
  saveLabel = "Save",
  saveDisabled = false,
  onCancel,
  onSave,
}: EditScreenHeaderProps) {
  return (
    <header className="grid items-center gap-3 pt-4 pb-2 px-4.5 bg-cream sticky top-0 z-[5] grid-cols-[auto_1fr_auto]">
      <RoundButton onClick={onCancel} aria-label="Cancel">
        <BackIcon size={20} stroke={2} />
      </RoundButton>
      <h1 className="font-display font-medium text-lg text-ink m-0 text-center tracking-tight">{title}</h1>
      <button
        onClick={onSave}
        disabled={saveDisabled}
        className="font-sans text-sm font-medium text-moss bg-transparent border-0 py-2 px-1 cursor-pointer tracking-[0.01em] disabled:text-ink-3 disabled:opacity-50 disabled:cursor-not-allowed enabled:hover:text-ink"
      >
        {saveLabel}
      </button>
    </header>
  );
}
